import { useCallback, useState } from "react";
import GridFacturaListado from "../Components/Factura/Listar/GridFacturaListado";
import FiltrosFacturas from "../Components/Factura/Listar/FiltrosFacturas";
import Boton from "../Components/UI/Boton";
import { IconoFiltrar } from "../Components/UI/Iconos";
import { usePageSubtitulo } from "../context/PageHeaderContext";

// SISTEMA-DE-DISENO · patrón LISTADO.
// Las migas de pan salen: el título vive en la barra superior y el conteo se
// publica como subtítulo. El panel de filtros sigue siendo el mismo Offcanvas
// de antes (no se toca su contenido), sólo cambia el botón que lo abre.
function FacturaListar() {
    const [showFilterInvoice, setShowFilterInvoice] = useState(false);
    const [filters, setFilters] = useState({});
    const [total, setTotal] = useState(null);

    const handleFilter = () => {
        setShowFilterInvoice(!showFilterInvoice);
    };

    const handleCloseFilter = () => {
        setShowFilterInvoice(!showFilterInvoice);
    };

    const updateFilters = (newFilters) => {
        setFilters(newFilters);
    };

    // Estable a propósito: el grid lo recibe dentro de `data` y una función
    // nueva en cada render volvería a disparar su efecto de carga.
    const handleTotal = useCallback((n) => setTotal(n), []);

    usePageSubtitulo(total === null ? "" : `${total} factura${total === 1 ? "" : "s"}`);

    return (
        <div className="page-content">
            <div className="container-fluid">
                <div className="d-flex justify-content-end mb-3">
                    <Boton icono={IconoFiltrar} onClick={handleFilter} data-testid="facturas-filtros">
                        Filtros
                    </Boton>
                </div>

                <GridFacturaListado data={{ filters, onTotal: handleTotal }} />
            </div>

            <FiltrosFacturas
                data={{
                    show: showFilterInvoice,
                    handleClose: handleCloseFilter,
                    filters: filters,
                    updateFilters: updateFilters,
                }}
            />
        </div>
    );
}

export default FacturaListar;
